module.exports = "/_next/static/images/6ab9caf2df56c38115d67ee6303bc328-pregnant-woman@mobile@3x.jpg.webp";